// M3 Inventory & Warehouse — data-testid registry.
export const INV = {
  navInventory: "nav-inventory",
  listTable: "inventory-table",
  listRow: (pid) => `inventory-row-${pid}`,
  searchInput: "inventory-search-input",
  statusFilter: "inventory-status-filter",
  warehouseFilter: "inventory-warehouse-filter",
  rackFilter: "inventory-rack-filter",
  pagePrev: "inventory-page-prev",
  pageNext: "inventory-page-next",
  registerReport: "inventory-register-report",

  detailHeader: "inventory-detail-header",
  detailStatus: "inventory-detail-status",
  detailLocation: "inventory-detail-location",
  detailQCEngineer: "inventory-detail-qc-engineer",

  locWarehouse: "loc-warehouse-input",
  locRack: "loc-rack-input",
  locShelf: "loc-shelf-input",
  locBin: "loc-bin-input",
  locRemarks: "loc-remarks-input",
  locBarcode: "loc-barcode-input",
  locSaveBtn: "loc-save-btn",

  reserveOpenBtn: "reserve-open-btn",
  reserveCustomerName: "reserve-customer-name",
  reserveCustomerMobile: "reserve-customer-mobile",
  reserveCity: "reserve-city",
  reservePrice: "reserve-price",
  reservePlatform: "reserve-platform",
  reserveSubmit: "reserve-submit",

  packOpenBtn: "pack-open-btn",
  packSerialVerify: "pack-serial-verify",
  packChkPassport: "pack-chk-passport",
  packChkSerial: "pack-chk-serial",
  packChkCharger: "pack-chk-charger",
  packChkAccessories: "pack-chk-accessories",
  packChkBox: "pack-chk-box",
  packChkLabel: "pack-chk-label",
  packSubmit: "pack-submit",

  shipOpenBtn: "ship-open-btn",
  shipCourier: "ship-courier",
  shipAWB: "ship-awb",
  shipDate: "ship-date",
  shipSubmit: "ship-submit",

  scrapOpenBtn: "scrap-open-btn",
  scrapReason: "scrap-reason",
  scrapRemarks: "scrap-remarks",
  scrapApproval: "scrap-approval",
  scrapSubmit: "scrap-submit",

  lostOpenBtn: "lost-open-btn",
  lostReason: "lost-reason",
  lostDate: "lost-date",
  lostPolice: "lost-police",
  lostSubmit: "lost-submit",
};
